import { Box, Skeleton } from "@mui/material"


const EmailSignatureSkeleton=()=>{

    const skeletonCards = Array(4).fill(null);

    return (
    <Box sx={{width: "100%"}}>
        <Box sx={{ 
            width: "70%",
            display: "grid", 
            gridTemplateColumns: "repeat(4, 1fr)", 
            gap: "20px",
            margin:"auto"
            
        }}>
            {skeletonCards.map((_, index) => (
                <Box key={index} >
                    <Box sx={{ pt: 0.5 }}>
                        <Skeleton width="78%" />
                        <Skeleton width="40%" />
                    </Box>
                    <Skeleton variant="rectangular" width={210} height={250} />
                </Box>
            ))}
        </Box> 

        <Box sx={{marginTop:"30px", width:"100%", marginLeft:"5%"}}>
        <Box sx={{ pt: 0.5 }}>
                        <Skeleton width="88%" />
                        <Skeleton width="70%" />
        </Box>
            <Skeleton variant="rectangular" width={"90%"}  height={"35vh"}  />
        </Box>
    </Box>

    )

}

export default EmailSignatureSkeleton